export enum ReleaseNoteOrganizationType {
    all = 'all',
    clinic = 'clinic',
    lab = 'lab',
}

export type ReleaseNoteTranslation = {
    language: string;
    content: string;
};

export type ReleaseNote = {
    _id: string;
    version: string;
    organizationType: ReleaseNoteOrganizationType;
    translations: ReleaseNoteTranslation[];
    isPublished: boolean;
    createdAt: string;
};

export type CreateReleaseNoteInput = {
    version: string;
    organizationType: ReleaseNoteOrganizationType;
    translations: ReleaseNoteTranslation[];
};

export type UpdateReleaseNoteInput = {
    organizationType: ReleaseNoteOrganizationType;
    translations: ReleaseNoteTranslation[];
    isPublished: boolean;
};
